import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AbilityServiceSignal } from '@casl/angular';
import { AppSnackService } from '../services/app-snack.service';
import { AppAbility, PermissionService } from '../services/permissions.service';

export const abilityGuard: CanActivateFn = async (route) => {
  // `inject` solo es válido en el contexto síncrono: se resuelve todo antes del primer `await`.
  const permissionSvc = inject(PermissionService);
  const { can } = inject<AbilityServiceSignal<AppAbility>>(AbilityServiceSignal);
  const router = inject(Router);
  const snack = inject(AppSnackService);

  await permissionSvc.ensureLoaded();

  const subject = route.data['subject'] as string | undefined;
  if (!subject) return true;
  if (can((route.data['action'] as string | undefined) ?? 'read', subject)) return true;

  const denyMessage = route.data['denyMessage'] as string | undefined;
  if (denyMessage) snack.openWithContext(denyMessage, 'error');
  return router.createUrlTree(['/home']);
};
